import React, { useState } from "react";
import { TextField, Grid, Typography, Card, CardContent, IconButton, Button, Box } from "@mui/material";
import { useFormikContext } from "formik";
import ReusableDialog from "../../../../common/dialog/dialog";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";

const SchoolInformation = ({ people, setPeople }) => {
  const { values, handleChange, handleBlur, touched, errors } = useFormikContext();
  const [newPerson, setNewPerson] = useState({
    position: "",
    personName: "",
    personYear: "",
  }); // State for current form input
  const [openSchool, setSchoolOpen] = useState(false);

  // Handle form input changes
  const handleSchoolChange = (event) => {
    const { name, value } = event.target;
    setNewPerson((prev) => ({ ...prev, [name]: value }));
  };

  // Add the new person to the list and reset form
  const handleAddPerson = () => {
    setPeople((prev) => [...prev, newPerson]); // Add new person to people array
    setNewPerson({ position: "", personName: "", personYear: "" }); // Reset form fields
    setSchoolOpen(false); // Close dialog
  };

  // Check if all fields are filled
  const isAddButtonDisabled = !(newPerson.position && newPerson.personName && newPerson.personYear);

  return (
    <>
      <Typography sx={{ fontSize: "18px", color: "black" }} mt={5}>
        School Information
      </Typography>
      <Grid container spacing={2} mt={1}>
        <Grid item xs={12} sm={10}>
          <Typography sx={{ fontSize: "14px", color: "black" }} align='left'>
            School Address
          </Typography>
          <TextField
            fullWidth
            placeholder='Enter your School Address'
            name='schoolAddress'
            value={values.schoolAddress}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.schoolAddress && Boolean(errors.schoolAddress)}
            helperText={touched.schoolAddress && errors.schoolAddress}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} mt={1}>
        <Grid item xs={12} sm={4}>
          <Typography sx={{ fontSize: "14px", color: "black" }} align='left'>
            Head Master
          </Typography>
          <TextField
            fullWidth
            placeholder='Enter your Head Master'
            name='headMaster'
            value={values.headMaster}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.headMaster && Boolean(errors.headMaster)}
            helperText={touched.headMaster && errors.headMaster}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Typography sx={{ fontSize: "14px", color: "black" }} align='left'>
            Head of Year
          </Typography>
          <TextField
            fullWidth
            type='date'
            name='headOfYear'
            value={values.headOfYear}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.headOfYear && Boolean(errors.headOfYear)}
            helperText={touched.headOfYear && errors.headOfYear}
          />
        </Grid>
      </Grid>

      <Grid container spacing={2} mt={1}>
        <Grid item xs={12} sm={10}>
          <Typography sx={{ fontSize: "14px", color: "black" }} align='left' mb={2}>
            Other
          </Typography>
          <Grid container spacing={2}>
            {people.map((person, index) => (
              <Grid item lg={6} xs={12} key={index}>
                <Card className='social-worker-card'>
                  <CardContent>
                    <Grid container spacing={2} alignItems='center'>
                      <Grid item xs={10}>
                        <Typography variant='subtitle1' className='role-title'>
                          {person.position}
                        </Typography>
                        <Grid container spacing={1} alignItems='center'>
                          <Grid item>
                            <Typography variant='body2'>{person.personName}</Typography>
                          </Grid>
                        </Grid>
                        <Grid container spacing={1} alignItems='center'>
                          <Grid item>
                            <Typography variant='body2'>{person.personYear}</Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={2} align='right'>
                        <IconButton>
                          <EditIcon />
                        </IconButton>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>

          {/* Add More Button */}
          <Button color='primary' mt={2} onClick={() => setSchoolOpen(true)}>
            <AddIcon /> Add more
          </Button>

          {/* Dialog for Adding New Person */}
          <ReusableDialog
            isOpen={openSchool}
            onClose={() => setSchoolOpen(false)}
            title='Add another school person?'
            contentText='Add the relevant details to the fields to add another person to the involved parties.'
            onSubmit={handleAddPerson}
            submitText='Add'
            cancelText='Cancel'
            disable={isAddButtonDisabled}
          >
            <Box mt={2}>
              <Grid container spacing={2} mt={1}>
                <Grid item xs={12} sm={8}>
                  <Typography sx={{ fontSize: "14px", color: "black" }} align='left'>
                    Position
                  </Typography>
                  <TextField
                    fullWidth
                    placeholder='Enter the position'
                    name='position'
                    value={newPerson.position}
                    onChange={handleSchoolChange}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2} mt={1}>
                <Grid item xs={12} sm={5}>
                  <Typography sx={{ fontSize: "14px", color: "black" }} align='left'>
                    Name
                  </Typography>
                  <TextField
                    fullWidth
                    placeholder='Enter Name of the person'
                    name='personName'
                    value={newPerson.personName}
                    onChange={handleSchoolChange}
                  />
                </Grid>
                <Grid item xs={12} sm={5}>
                  <Typography sx={{ fontSize: "14px", color: "black" }} align='left'>
                    Year
                  </Typography>
                  <TextField
                    fullWidth
                    type='date'
                    name='personYear'
                    value={newPerson.personYear}
                    onChange={handleSchoolChange}
                  />
                </Grid>
              </Grid>
            </Box>
          </ReusableDialog>
        </Grid>
      </Grid>
    </>
  );
};

export default SchoolInformation;
